import { SvgIcon } from '@mui/material';
import { FC } from 'react';

import { IconProps } from './types';

export const AllReportIcon: FC<IconProps> = ({ width = 24, height = 24 }) => {
  return (
    <SvgIcon width={width} height={height} viewBox={[0, 0, width, height].join(' ')} fill="none" stroke="none" 
    strokeWidth={0} xmlns="http://www.w3.org/2000/svg">
      <path d="M21.8576 6.27522H12.2415L9.09953 3.26987C9.05955 3.23244 9.00697 3.21141 8.95221 3.21094H2.14328C1.66917 3.21094 1.28613 3.59397 1.28613 4.06808V19.9252C1.28613 20.3993 1.66917 20.7824 2.14328 20.7824H21.8576C22.3317 20.7824 22.7147 20.3993 22.7147 19.9252V7.13237C22.7147 6.65826 22.3317 6.27522 21.8576 6.27522ZM20.7861 18.8538H3.2147V5.13951H8.26381L11.4674 8.20379H20.7861V18.8538Z"/>
    </SvgIcon>
  );
};
